import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IArticle } from '~/api/article'

export default function useSeo(item?: IArticle) {
  const globalStore = useGlobalStore()

  const title = `${item?.seo?.meta_title || item?.subject}｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = item?.seo?.meta_description
  const url = item?.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/sustainability/article/${item?.seo?.meta_slug || item?.id}`

  globalStore.setBreadcrumbs([
    { title: '永續生活', isActive: false, url: `/sustainability` },
    { title: item?.categories?.[0]?.seo?.meta_title || '', isActive: false, url: `/sustainability/${item?.categories?.[0]?.seo?.meta_slug || item?.categories?.[0]?.id}` },
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: item?.seo?.og_image?.link,
    keywords: item?.seo?.meta_keywords?.join(',')
  })

  let meta = []
  if (!item?.status) {
    meta.push({ hid: 'robots', name: 'robots', content: 'noindex' })
  }

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ],
    meta: meta
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '永續生活',
            item: `${import.meta.env.VITE_DOMAIN}/news`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: item?.categories?.[0]?.seo?.meta_title,
            item: `${import.meta.env.VITE_DOMAIN}/sustainability/${item?.categories?.[0]?.seo?.meta_slug || item?.categories?.[0]?.id}`
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: item?.seo?.meta_title,
            item: url
          }
        ]
      }
    ]
  })
}
